/**
 * Launch promotion: the whole platform is free for everyone until the end of
 * 30 November 2026, Hobart time (AEDT, UTC+11) = 2026-11-30T13:00:00Z.
 *
 * While the promo is active every account is treated as the `promo` plan:
 * full features, 3,000 credits/month, no checkout anywhere in the app.
 * After it lapses, everything reverts to the real plan automatically.
 */
export const PROMO_END = new Date('2026-11-30T13:00:00Z');

export function isPromoActive(now: Date = new Date()): boolean {
  return now.getTime() < PROMO_END.getTime();
}

export const PROMO_HEADLINE = 'Free for everyone until 30 November';
export const PROMO_BLURB =
  'Every feature is unlocked for every account — no card, no plan, no catch. Normal pricing resumes 1 December 2026.';
export const PROMO_END_LABEL = '30 November 2026';
